<template>
  <div>
    <navbar
      :min-nav="navbarMinimize"
      :toggle="toggleConfigurator"
      :class="isNavFixed ? navbarFixed : ''"
    />
  </div>
  <div
    class="mx-3 mt-3 border-radius-xl position-relative"
  >
    <main class="mt-1 main-content border-radius-lg">
      <div
        class="section position-relative transform-scale-0 transform-scale-md-7"
        style="min-height: 89vh;"
      >
        <div class="container-fluid">
          <div class="pt-5 row justify-content-center">
            <div class="col-lg-8 col-md-11">
              <div class="d-flex">
                <div class="me-auto">
                  <h1 class="mb-0 display-3 font-weight-bold mt-n4">그룹 선택</h1>
                  <h6 class="mb-0 text-uppercase ms-1">Choose a group</h6>
                </div>
                <div class="ms-auto">
                </div>
              </div>
              <div class="mt-4 row">
                <div
                  v-for="(group, index) in groups"
                  :key="index"
                  class="col-lg-4 col-md-6 col-sm-12 mb-4"
                >
                  <group-card :id="group.id" :text="group.text" :decs="group.decs" :tooltip="group.tooltip" :icon="group.icon" :route="group.route" :useable="group.useable" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  <app-footer class="py-3 bg-white border-radius-lg" />
</template>

<script>
import AppFooter from "@/examples/Footer.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import GroupCard from "./components/GroupCard.vue";
import setTooltip from "@/assets/js/tooltip.js";

const body = document.getElementsByTagName("body")[0];

import { mapMutations, mapState } from "vuex";

export default {
  name: "SelGroup",
  components: {
    AppFooter,
    Navbar,
    GroupCard,
  },
  data() {
    return {
      groups: [
        { id: '1', text: '제조사', decs: 'Manufacturer', tooltip: "제품의 제조 및 패키징 과정을 기록하며, 고유 식별자(EPC)를 부여합니다.", icon: 'fa fa-industry', route: '/sel-mf', useable: true },
        { id: '2', text: '유통사', decs: 'Distributor', tooltip: "제품의 창고 보관, 운송, 입출고 이벤트를 EPCIS에 기록합니다.", icon: 'fa fa-truck', route: '/dashboard'  },
        { id: '3', text: '안경점', decs: 'Retailer', tooltip: "제품 수령 및 판매 이력을 기록하여 소비자가 추적할 수 있도록 합니다.", icon: 'fa fa-store', route: '/dashboard'  },
      ],
    };
  },
  computed: {
    ...mapState(["isTransparent", "isNavFixed", "navbarFixed", "mcolor"]),
  },
  mounted() {
    setTooltip(this.$store.state.bootstrap);
  },
  beforeMount() {
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.add("group-sel");
    this.$store.state.isTransparent = "bg-white";
  },
  beforeUnmount() {
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.remove("group-sel");

    if (this.$store.state.isPinned === false) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      sidenav_show.classList.remove("g-sidenav-hidden");
      sidenav_show.classList.add("g-sidenav-pinned");
      this.$store.state.isPinned = true;
    }
    this.$store.state.isTransparent = "bg-transparent";
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
  },
};
</script>
